<mat-toolbar *ngIf="isLoggedIn" style="background-color: #e6e6e6;">
    <img src="logo_hitec.png" alt="logo" width="80" height="50">
    <button mat-icon-button (click)="navigateTo('home')" aria-label="Example icon-button with menu icon">
      <mat-icon>apps</mat-icon>
    </button>
    <span class="spacer"></span>
    <button mat-icon-button aria-label="Example icon-button with share icon" (click)="logout()">
        <mat-icon>logout</mat-icon>
    </button>
</mat-toolbar>
<router-outlet></router-outlet>